// To organize imports in a better way
/* eslint-disable import/order */
import 'reflect-metadata'; // include once in the app for inversify (see: https://github.com/inversify/InversifyJS/blob/master/README.md#-installation)
import type { ResolutionContext } from 'inversify';
import { container } from './container';

import ApiService from '../services/ApiService';
import AppController from '../controllers/AppController';
import DateService from '../services/DateService';
import ContinueWatchingService from '../services/ContinueWatchingService';
import InfoPanelService from '../services/InfoPanelService';
import SearchService from '../services/SearchService';
import NotificationsService from '../services/NotificationsService';
import type { Reference, Structure } from '../../types/immstruct';

// @ts-ignore
import VideoService from '@debatdirect/core/services/VideoService/VideoService';
// @ts-ignore
import ShareService from '@debatdirect/core/services/ShareService/ShareService';
// @ts-ignore
import InteractionService from '@debatdirect/core/services/InteractionAdditionsService/AdditionsServiceFactory';
// @ts-ignore
import VideoSyncService from '@debatdirect/core/services/VideoSyncService/VideoSyncService';
// @ts-ignore
import DownloadService from '@debatdirect/core/services/DownloadService/DownloadService';
// @ts-ignore
import AuthService from '@debatdirect/core/services/AuthService/AuthService';
// @ts-ignore
import PromptService from '@debatdirect/core/services/PromptService/PromptService';
import StorageService from '../services/StorageService';

export const bindLegacyService = (factory: (reference: Reference) => object) => (context: ResolutionContext) => {
  return factory(context.get<Structure>('structure').reference([]));
};

// Common services
container.bind('api').to(ApiService);
container.bind('date').to(DateService);
container.bind('continue-watching').to(ContinueWatchingService);
container.bind('info-panel').to(InfoPanelService);
container.bind('search').to(SearchService);
container.bind('notifications').to(NotificationsService);
container.bind('download').to(DownloadService);
container.bind('prompt').to(PromptService);

container.bind('video').toDynamicValue(bindLegacyService(VideoService));
container.bind('share').toDynamicValue(bindLegacyService(ShareService));
container.bind('interaction-additions').toDynamicValue(bindLegacyService(InteractionService));
container.bind('video-sync').toDynamicValue(bindLegacyService(VideoSyncService));

container.bind('storage').toDynamicValue(() => container.get(StorageService));

// Common controllers
container.bind('app').to(AppController);
